import { useQuery, useQueryClient } from "@tanstack/react-query";

import { LocationPreferences } from "../models/LocationPreferences";
import DataSvc from "../services/dataSvc";

export const useLocationPreferences = (locationId: number) => {
  const queryClient = useQueryClient();
  const queryKey = ["location-preferences", locationId.toString()];

  const query = useQuery<LocationPreferences>(queryKey, () => {
    return DataSvc.getLocationPreferences(locationId);
  });

  const update = async (id: number, data: LocationPreferences) => {
    await DataSvc.updateLocationPreferences(id, data);
    queryClient.setQueryData(queryKey, data);
    queryClient.invalidateQueries({
      queryKey: queryKey
    });
  };

  return { ...query, update };
};
